export const RECAPTCHA_BRANDING_TEXT_EXTRA_MESSAGE = 'All information submitted to us will be treated with confidentiality.'; // @suppress longLineCheck
